<sharry-header></sharry-header>
<div class="become-pro">
  <div class="become-pro__hero">
    @if (isPlatformBrowser()) {
      <div class="become-pro__hero__wrapper">
        <div
          class="become-pro__hero__wrapper--animated"
          [@slideInOut]="heroIndex"
          (@slideInOut.done)="animationDone()">
          <p
            [class]="
              'become-pro__hero__wrapper--animated--text become-pro__hero__wrapper--animated--text--' +
              heroItems[heroIndex]
            ">
            {{ 'become-pro.hero.' + heroItems[heroIndex] | i18next }}
          </p>
          <img
            alt="hero"
            [height]="280"
            [src]="'https://media.sharry.land/app/images/become-pro/hero-' + heroItems[heroIndex] + '.png'" />
        </div>
        <div
          [class]="
            'become-pro__hero__wrapper--circle become-pro__hero__wrapper--circle--' + heroItems[heroIndex]
          "></div>
      </div>
    }
    <h1>{{ 'become-pro.hero.title' | i18next }}</h1>
    <p [innerHTML]="'become-pro.hero.description' | i18next"></p>
  </div>
  <div class="become-pro__numbered">
    <div class="become-pro__numbered__item">
      <span>1</span>
      <h3>{{ 'become-pro.numbered.one.title' | i18next }}</h3>
      <p>{{ 'become-pro.numbered.one.desc.first' | i18next }}</p>
    </div>
    <div class="become-pro__numbered__item">
      <span>2</span>
      <h3>{{ 'become-pro.numbered.two.title' | i18next }}</h3>
      <p>
        {{ 'become-pro.numbered.two.desc' | i18next }}
      </p>
    </div>
    <div class="become-pro__numbered__item">
      <span>3</span>
      <h3>{{ 'become-pro.numbered.three.title' | i18next }}</h3>
      <p>{{ 'become-pro.numbered.three.desc' | i18next }}</p>
    </div>
    <div class="become-pro__numbered__item--empty"></div>
    <div class="become-pro__numbered__item">
      <span>4</span>
      <h3>{{ 'become-pro.numbered.four.title' | i18next }}</h3>
      <p>{{ 'become-pro.numbered.four.desc' | i18next }}</p>
    </div>
    <div class="become-pro__numbered__item">
      <span>5</span>
      <h3>{{ 'become-pro.numbered.five.title' | i18next }}</h3>
      <p>{{ 'become-pro.numbered.five.desc' | i18next }}</p>
    </div>
  </div>
  <div class="become-pro__dynamic-section">
    @if (userService.user) {
      @if (userService.user.stripePayoutsEnabled && userService.user.stripeAccountCompleted) {
        <ng-container [ngTemplateOutlet]="promo"></ng-container>
        <p
          class="become-pro__dynamic-section__stripe-paragraph"
          [innerHTML]="'become-pro.dynamic-section.completed' | i18next"></p>
      } @else {
        <ng-container [ngTemplateOutlet]="promo"></ng-container>
        <p class="become-pro__dynamic-section__stripe-paragraph">
          {{
            userService.user.isSmallOrganisation
              ? ('become-pro.dynamic-section.activate-stripe' | i18next)
              : ('become-pro.dynamic-section.signup' | i18next)
          }}
        </p>
        @if (userService.user.isSmallOrganisation) {
          <button
            mat-flat-button
            color="rainbow"
            class="sharry-medium rounded"
            (click)="openStripeDialog()">
            {{ 'become-pro.dynamic-section.not-activated.button' | i18next }}
          </button>
        }
      }
    } @else {
      <ng-container [ngTemplateOutlet]="promo"></ng-container>
      <p
        class="become-pro__dynamic-section__stripe-paragraph"
        [innerHTML]="'become-pro.dynamic-section.not-logged.text' | i18next"></p>
      <a
        mat-flat-button
        color="rainbow"
        class="sharry-medium rounded"
        [routerLink]="[]"
        [queryParams]="{ signup: true }"
        (click)="setSmallOrganization()">
        {{ 'become-pro.dynamic-section.not-logged.button' | i18next }}
      </a>
    }
    <ng-template #promo>
      <h3>{{ 'become-pro.promo.title' | i18next }}</h3>
      <ul class="become-pro__dynamic-section__advantages">
        <li>
          <span>{{ 'become-pro.promo.price' | i18next }}</span
          ><span class="become-pro__dynamic-section__advantages--bolder">0€</span>
        </li>
        <li>
          <span>{{ 'become-pro.promo.monthly' | i18next }}</span
          ><span class="become-pro__dynamic-section__advantages--bolder">0€</span>
        </li>
        <li>
          <span>{{ 'become-pro.promo.transactions' | i18next }}</span
          ><span class="become-pro__dynamic-section__advantages--bolder">{{ 'become-pro.promo.iva' | i18next }}</span>
        </li>
      </ul>
      <p class="become-pro__dynamic-section__excluded">{{ 'become-pro.promo.commissions' | i18next }}</p>
    </ng-template>
  </div>
  <div class="become-pro__gallery">
    <div class="become-pro__gallery__content">
      <img
        alt="business"
        width="500"
        height="500"
        [src]="galleryItems[galleryIndex].src" />
      <div class="become-pro__gallery__content__text">
        <h3>{{ galleryItems[galleryIndex].businessKind | i18next }}</h3>
        <p class="become-pro__gallery__content__text--desc">❝ {{ galleryItems[galleryIndex].quotation | i18next }} ❞</p>
        <p class="become-pro__gallery__content__text--bottom">
          {{ galleryItems[galleryIndex].businessName | i18next }}
        </p>
      </div>
    </div>
    <div class="become-pro__gallery__controls">
      <button
        mat-icon-button
        class="sharry-xxl bordered"
        color="secondary"
        [disabled]="galleryIndex === 0"
        (click)="galleryIndex = galleryIndex - 1; resetGalleryTimer()">
        <sharry-icon
          type="phosphor"
          name="caret-left"></sharry-icon>
      </button>
      <div class="become-pro__gallery__controls--index">
        @for (item of galleryItems; track item; let index = $index) {
          <span [ngClass]="{ 'become-pro__gallery__controls--index--current': galleryIndex === index }"></span>
        }
      </div>
      <button
        mat-icon-button
        class="sharry-xxl bordered"
        color="secondary"
        [disabled]="galleryIndex === galleryItems.length - 1"
        (click)="galleryIndex = galleryIndex + 1; resetGalleryTimer()">
        <sharry-icon
          type="phosphor"
          name="caret-right"></sharry-icon>
      </button>
    </div>
  </div>
  <div class="become-pro__services">
    <h2>{{ 'become-pro.services.title' | i18next }}</h2>
    <div class="become-pro__services__wrapper">
      @for (service of services; track service) {
        <div class="become-pro__services__wrapper--item">
          <span>
            <sharry-icon
              svgClass="svg-icon"
              [type]="service.iconType"
              [name]="service.icon"></sharry-icon>
          </span>
          <h3>{{ 'become-pro.services.title.' + service.text | i18next }}</h3>
          <p [innerHTML]="'become-pro.services.desc.' + service.text | i18next"></p>
        </div>
      }
    </div>
  </div>
  <div class="become-pro__reviews">
    <div class="become-pro__reviews__title">
      <h2>{{ 'become-pro.about-us.title' | i18next }}</h2>
    </div>
    <div class="become-pro__reviews__review-container">
      @for (quote of quotations; track quote; let last = $last; let first = $first) {
        <div
          class="become-pro__reviews__review-container__review"
          [ngClass]="{ last: last, first: first }">
          <div class="become-pro__reviews__review-container__review__quote-container">
            <span class="become-pro__reviews__review-container__review__quote-container__quote"></span>
            <div class="become-pro__reviews__review-container__review__quote-container__caption-container">
              <blockquote [innerHTML]="quote.review | i18next"></blockquote>
              <figure
                class="become-pro__reviews__review-container__review__quote-container__caption-container__caption">
                <img
                  width="56"
                  height="56"
                  [src]="quote.src"
                  [alt]="quote.reviewer | i18next" />
                <figcaption>
                  <cite>{{ quote.reviewer | i18next }}</cite
                  ><br />{{ quote.reviewerDesc | i18next }}
                </figcaption>
              </figure>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
  <div class="become-pro__project">
    <img
      src="https://media.sharry.land/app/images/become-pro/man-pink.webp"
      alt="project" />
    <div class="become-pro__project__text">
      <h2>{{ 'become-pro.project.title' | i18next }}</h2>
      <p [innerHTML]="'become-pro.project.desc' | i18next"></p>
      <a
        mat-flat-button
        color="primary"
        class="sharry-medium rounded"
        href="https://info.sharry.land/guida/servizi-pro-chiavi-in-mano.html"
        target="_blank">
        {{ 'become-pro.project.btn' | i18next }} </a
      ><!--(click)="openSupportDialog()"-->
    </div>
  </div>
  <div class="become-pro__faqs-container">
    <div class="become-pro__faqs-container__title">
      <h2>{{ 'become-pro.faq.title' | i18next }}</h2>
      <p>
        {{ 'become-pro.faq.desc' | i18next }}&nbsp;<a
          [routerLink]="'faq' | routeTranslate"
          [queryParams]="{ area: '2' }"
          >{{ 'become-pro.faq.link' | i18next }}
          <sharry-icon
            registryName="caret-right"
            svgClass="svg-icon caret"></sharry-icon>
        </a>
      </p>
      <p>
        {{ 'become-pro.check-guide' | i18next }}&nbsp;
        <a
          href="https://info.sharry.land"
          target="_blank"
          >{{ 'footer.sharryland.pro-guide' | i18next }}
          <sharry-icon
            registryName="caret-right"
            svgClass="svg-icon caret"></sharry-icon>
        </a>
      </p>
    </div>
    <div class="become-pro__faqs-container__faqs">
      <mat-accordion
        displayMode="flat"
        [multi]="true">
        @for (panel of accordionPanels; track panel; let last = $last) {
          <mat-expansion-panel
            class="sharry-flat-panel"
            [id]="panel.id">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ panel.title | i18next }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p>
              {{ panel.desc | i18next }}
            </p>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
  </div>
</div>
<sharry-footer class="is-not-mobile"></sharry-footer>
